export default __webpack_public_path__ + "static/otterclam-f6d31c95dd525b63047c38117ff7069e.jpg";